import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce, escape } from 'lodash';

import { changeTextProperty } from './../../../redux/actions/entities/texts';

class TextInput extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      text: null,
    };
    this.changeText = debounce(this.changeText, 500);
  }

  handleChange = (event) => {
    const { value } = event.target;
    let replacedText = value.replace(/[[\]{}*+\\^$|#\t]/g, '');
    replacedText = replacedText.replace(/<br>/g, /\n/g);
    this.setState({ text: replacedText });
    this.changeText();
  }

  changeText = () => {
    const { textFieldId } = this.props;
    this.props.dispatch(changeTextProperty(textFieldId, 'text', escape(this.state.text.replace(/\n/g, '<br>'))));
  }

  render() {
    const {
      text,
      lang,
    } = this.props;
    const { text: stateText } = this.state;

    const textValue = text.replace(/<br>/g, '\n');

    return (
      <div className="col textToolsIcon text-input-wrapper">
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="15.91" height="15.91" viewBox="0 0 15.91 15.91">
          <path d="M13.13.05,11,2.17,1.08,12.09h0L.05,16l3.86-1h0L13.83,5,16,2.87ZM3.91,13.23,2.77,12.09,11.85,3,13,4.15Z" transform="translate(-0.05 -0.05)" />
        </svg>

        <textarea
          ref={input => input && input.focus()}
          type="text"
          className="bookText"
          value={stateText !== null ? stateText : textValue}
          onChange={this.handleChange}
          placeholder={lang.text_input_placeholder}
        />
      </div>

    );
  }
}

TextInput.defaultProps = {
  text: '',
  textFieldId: 0,
  lang: {},
  dispatch: () => {},
};

TextInput.propTypes = {
  text: PropTypes.string,
  textFieldId: PropTypes.number,
  lang: PropTypes.object,
  dispatch: PropTypes.func,
};

export default connect()(TextInput);



// WEBPACK FOOTER //
// ./src/components/text-tools/text-input/TextInput.jsx